import * as React from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { compose, mapProps } from 'recompose';
import { RouteComponentProps, withRouter } from 'react-router';

import PATHS from 'src/constants/paths';

import IMPComponent from 'src/components/interfaces/IMPComponent';

import MagicBall from 'src/components/MagicBall';
import NewPageButton from 'src/components/NewPageButton';

import { getQuoteMessageId } from '../selectors';
import { getSelectedDate } from '../../PagesHistoryCalendar/selectors';

import './styles.scss';
import { getStreakInfo } from '../../../../components/StreakInfo/StreakLogic';

interface ICreatePageProps extends IMPComponent, RouteComponentProps {
  quoteMessageId: string;
  isToday: boolean;
  isFuture: boolean;
  isPast: boolean;
  isFarFuture: boolean;
  isStreakRepaired: boolean;
  selectedDate: string;
}

const MESSAGE_BASE = 'containers.PagesHistory.CreatePage';

const enhance = compose(
  withRouter,
  connect(state => {
    return {
      quoteMessageId: getQuoteMessageId(state),
      selectedDate: getSelectedDate(state),
      streakInfo: getStreakInfo(state),
    };
  }),
  mapProps((props: any) => {
    const selectedDate = new Date(props.selectedDate);
    return {
      ...props,
      isStreakRepaired: props.streakInfo.isStreakRepaired(selectedDate),
      isToday: moment().isSame(props.selectedDate, 'day'),
      isFuture: moment().isBefore(props.selectedDate, 'day'),
      isPast: moment().isAfter(props.selectedDate, 'day'),
      isFarFuture: moment(props.selectedDate).isAfter(moment().add(1, 'day')),
    };
  }),
);

class CreatePage extends React.PureComponent<ICreatePageProps> {
  public render() {
    const { quoteMessageId, isToday, isPast, isFuture, isFarFuture, isStreakRepaired } = this.props;
    let magicBallMessageId = isPast ? 'missed' : 'focusOnTomorrow';

    if (isFarFuture) {
      magicBallMessageId = 'tryNotToBrakeTheChain';
    }

    let message = `${MESSAGE_BASE}.${magicBallMessageId}`;

    if (quoteMessageId && isToday) {
      message = quoteMessageId;
    }

    if (isStreakRepaired) {
      message = 'components.StreakNavbar.repaired';
    }

    return (
      <>
        <div className="CreatePage-button">
          {!isFuture ? (
            <NewPageButton onClick={this.handleClick} gray={isPast} imageWidth={400} />
          ) : (
            <MagicBall disabled={isPast} />
          )}
        </div>
        <div className="CreatePage-quote">
          <FormattedMessage id={message} />
        </div>
      </>
    );
  }

  private handleClick = () => {
    const { history } = this.props;

    history.push(PATHS.PAGES.NEW);
  };
}

export default enhance(CreatePage);



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryHome/CreatePage/index.tsx